// The --theme-* tokens come with the Header stylesheet (HeaderFooterCollections.css).
import './HeaderFooterNavigationSync.css';
import { useHeaderFooterThemeSync } from './headerFooterCollections';

// Header & Footer Collections → the rest of the navigation (sub-navigation bar,
// main menu drawer, filter drawer, dropdowns). Renders nothing: it mirrors the
// active collection on <html data-hf-theme>, live (switch, preview, refresh).
const HeaderFooterThemeSync = ({ infoSource }) => {
  useHeaderFooterThemeSync(infoSource);
  return null;
};

export default HeaderFooterThemeSync;
